<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <DataTable
      v-show="mostrarSkeleton == false"
      :tableTitle="'Aprovar dispensas feitas para unidade'"
      :tableHeader="headers"
      :tableRows="listaDispensasUnidade"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
      :isEditDispensaUnidade="true"
      :isViewDispensaUnidade="true"
      v-on:datatable-imprimir="imprimirTransferencia"
      v-on:datatable-updaterow="modalDeAtualizar"
      v-on:datatable-viewrow="modalDeVisualizar"
    ></DataTable>

    <SkeletonTable v-show="mostrarSkeleton == true" :showSkeletonTable="mostrarSkeleton"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="acoesModal"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-form v-model="tudoValido">
        <v-row>
          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.dadosModal.responsavelDispensa" label="Responsável Dispensa" autocomplete="off" disabled></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on }">
                <v-text-field
                  disabled
                  v-on="on"
                  v-model="modalCustomSize.dadosModal.dataDispensaFormatada"
                  label="Data dispensa"
                  hint="DD/MM/AAAA"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  autocomplete="off"
                  v-mask="['##/##/####']"
                  :rules="[rules.requerido]"
                  @blur="modalCustomSize.dadosModal.dataDispensa = analizarData(modalCustomSize.dadosModal.dataDispensaFormatada)"
                ></v-text-field>
              </template>
              <v-date-picker v-model="modalCustomSize.dadosModal.dataDispensa" no-title @input="menu = false" @change="modalCustomSize.dadosModal.dataDispensaFormatada = formatarData(modalCustomSize.dadosModal.dataDispensa)"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="modalCustomSize.dadosModal.descricaoObservacao" name="descricaoObservacao" label="Descrição" autocomplete="off" rows="1" auto-grow disabled></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="modalCustomSize.dadosModal.nomeEnderecoSaida" name="nomeEnderecoSaida" label="Unidade responsável pela Dispensa" autocomplete="off" rows="1" auto-grow disabled></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12"><v-divider></v-divider></v-col>

          <v-col cols="12" v-if="!modalCustomSize.isView">
            <DatatableAprovarDispensa :tableTitle="'Produtos dispensados para unidade'" :tableHeader="headersItens" :tableRows="modalCustomSize.dadosModal.produtosDispensados"></DatatableAprovarDispensa>
          </v-col>

          <v-col cols="12" v-if="modalCustomSize.isView">
            <v-data-table :headers="headersItens" :search="searchItemDispensa" :items="modalCustomSize.dadosModal.produtosDispensados" disable-sort>
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>

              <template v-slot:[`item.validade`]="{ item }">
                <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-autocomplete v-model="modalCustomSize.dadosModal.indicadorStatus" clearable label="Aprovar ou Recusar" :items="listaStatus" :rules="[rules.requeridoStatus]" :disabled="modalCustomSize.isView"></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";
import DataTable from "@/components/DataTable2.vue";
import DatatableAprovarDispensa from "@/components/DatatableAprovarDispensa.vue";
import SkeletonTable from "../components/SkeletonTable";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";

export default {
  components: {
    Alertas,
    AlertasModal,
    AlertaSnackbar,
    DataTable,
    DatatableAprovarDispensa,
    SkeletonTable,
    Loading,
    ModalCustomSize,
  },

  data: () => ({
    //#region Paginação
    page: 1,
    search: null,
    total: null,
    searchItemDispensa: null,
    //#endregion

    //#region Alertas
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },
    //#endregion

    rules: {
      requerido: (value) => (value != null && value != "") || "Requer o campo!",
      requeridoStatus: (value) => (value != 0 && value != null && value != "") || "Por favor, altere o status!",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    headers: [
      {
        text: "ID",
        value: "dispensaUnidade.numeroDispensaUnidade",
      },
      {
        text: "Descrição",
        value: "dispensaUnidade.descricaoObservacao",
      },
      {
        text: "Enviado por",
        value: "enderecoSaida.nomeEndereco",
      },
      {
        text: "Responsável Dispensa",
        value: "funcionarioSaida.nomeFuncionario",
      },
      {
        text: "Data Dispensa",
        value: "dispensaUnidade.dataDispensa",
      },
      {
        text: "Aceito/Recusado por",
        value: "funcionario.nomeFuncionario",
      },
      {
        text: "Status",
        value: "dispensaUnidade.indicadorStatus",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "numeroItemDispensaUnidade",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Produto",
        value: "nomeItemNaoPadronizado",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeDispensada",
      },
    ],

    modalCustomSize: {
      size: "1600",
      isOpen: false,
      isEdit: false,
      isView: false,
      formTitle: "",
      buttonText: "Concluir",
      isButtonsVisible: false,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      dadosModal: {
        numeroDispensaUnidade: null,
        numeroEnderecoSaida: null,
        nomeEnderecoSaida: null,
        numeroEndereco: null,
        responsavelDispensa: null,
        descricaoObservacao: null,
        dataDispensa: null,
        dataDispensaFormatada: null,
        indicadorStatus: null,

        produtosDispensados: [],
        produtosDispensadosExcluidos: [],
      },
    },

    menu: false,
    loading: false,
    tudoValido: false,
    mostrarSkeleton: true,

    mostrarDadosPaciente: false,

    itemSelecionado: null,

    listaDispensasUnidade: [],
    listaStatus: [
      {
        value: 0,
        text: "AGUARDANDO APROVAÇÃO",
      },
      {
        value: 1,
        text: "APROVAR",
      },
      {
        value: 2,
        text: "RECUSAR",
      },
    ],
  }),

  created() {
    this.mostrarSkeleton = true;
    this.inicializar();
  },

  watch: {
    tudoValido() {
      this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
    },
  },

  methods: {
    //#region LISTAGENS
    async inicializar() {
      try {
        const response = await axios.put("listadispensaunidade", { page: this.page, search: this.search, numeroUnidade: store.state.numeroEndereco }, this.config);
        if (!response.data || response.data.length > 0) {
          this.listaDispensasUnidade = response.data;
          this.total = response.data[0].total;
        } else {
          this.listaDispensasUnidade = [];
          this.total = 0;
        }
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.mostrarSkeleton = false;
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.inicializar();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.inicializar();
    },

    async listarProdutosDispensados(numeroDispensaUnidade) {
      try {
        this.alertaModal.tipo = "";
        const response = await axios.put("produtosdispensaunidade", { numeroDispensaUnidade: numeroDispensaUnidade }, this.config);
        
        return response.data.map((produtoDispensadoSelecionado) => {
          return {
            numeroDispensaUnidade: produtoDispensadoSelecionado.numeroDispensaUnidade,
            numeroItemDispensaUnidade: produtoDispensadoSelecionado.numeroItemDispensaUnidade,
            numeroItem: produtoDispensadoSelecionado.numeroItem,
            numeroItemUnidade: produtoDispensadoSelecionado.numeroItemUnidade,
            nomeItem: produtoDispensadoSelecionado.nomeItem,
            nomeItemNaoPadronizado: produtoDispensadoSelecionado.nomeItemNaoPadronizado,
            lote: produtoDispensadoSelecionado.lote,
            validade: produtoDispensadoSelecionado.validade,
            indicadorStatusFamilia: produtoDispensadoSelecionado.indicadorStatusFamilia,
            quantidadeAtual: produtoDispensadoSelecionado.quantidadeAtual,
            quantidadePreviamenteDispensada: produtoDispensadoSelecionado.quantidadePreviamenteDispensada,
            quantidadeDispensada: produtoDispensadoSelecionado.quantidadeDispensada,
            cor: "red",
            padronizado: false,
            nomeItemSistema: null,
            nomeProdutoPadronizado: null,
            numeroItemSistemaUnidade: null,
          };
        });
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },
    //#endregion

    //#region EVENTOS REQUISIÇÃO
    async acoesModal() {
      try {
        this.loading = true;
        if (this.modalCustomSize.isEdit) {
          await this.atualizar();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async atualizar() {
      try {
        if(confirm(this.modalCustomSize.dadosModal.indicadorStatus == 1 ? "Deseja aprovar o recebimento dos produtos dispensado para sua unidade?" : "ATENÇÃO! Você realmente deseja recusar essa dispensa para sua unidade?")) {
          this.alertaModal.tipo = "";
          await axios.put("statusdispensaunidade", this.modalCustomSize.dadosModal, this.config);
  
          if(this.modalCustomSize.dadosModal.indicadorStatus == 1) {
            this.alerta.texto = "Dispensa para unidade aprovada com sucesso!";
            this.alerta.tipo = "sucesso";
          } else {
            this.alerta.texto = "Dispensa para unidade recusada com sucesso!";
            this.alerta.tipo = "sucesso";
          }
  
          this.modalCustomSize.isOpen = false;
          this.mostrarSkeleton = true;
          this.inicializar();
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },
    //#endregion

    //#region FUNÇÕES MODAL
    async modalDeAtualizar(dispensaSelecionada) {
      this.loading = true;
      try {
        this.alertaModal.tipo = "";

        this.itemSelecionado = null;

        this.modalCustomSize.dadosModal.numeroDispensaUnidade = dispensaSelecionada.dispensaUnidade.numeroDispensaUnidade;
        this.modalCustomSize.dadosModal.numeroEndereco = dispensaSelecionada.endereco.numeroEnderecoOrdemServico;
        this.modalCustomSize.dadosModal.numeroEnderecoSaida = dispensaSelecionada.enderecoSaida.numeroEnderecoOrdemServico;
        this.modalCustomSize.dadosModal.nomeEnderecoSaida = dispensaSelecionada.enderecoSaida.nomeEndereco;
        this.modalCustomSize.dadosModal.responsavelDispensa = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.dadosModal.descricaoObservacao = dispensaSelecionada.dispensaUnidade.descricaoObservacao;
        this.modalCustomSize.dadosModal.dataDispensa = this.formataDataBanco(dispensaSelecionada.dispensaUnidade.dataDispensa);
        this.modalCustomSize.dadosModal.dataDispensaFormatada = this.formataDataBancoTipoPadrao(this.modalCustomSize.dadosModal.dataDispensa);
        this.modalCustomSize.dadosModal.indicadorStatus = dispensaSelecionada.dispensaUnidade.indicadorStatus;

        this.modalCustomSize.dadosModal.produtosDispensados = [];
        this.modalCustomSize.dadosModal.produtosDispensados = await this.listarProdutosDispensados(dispensaSelecionada.dispensaUnidade.numeroDispensaUnidade);
        this.modalCustomSize.dadosModal.produtosDispensadosExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "Atualizar Dispensa";
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isView = false;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeVisualizar(dispensaSelecionada) {
      this.loading = true;
      try {
        this.alertaModal.tipo = "";

        this.itemSelecionado = null;

        this.modalCustomSize.dadosModal.numeroDispensaUnidade = dispensaSelecionada.dispensaUnidade.numeroDispensaUnidade;
        this.modalCustomSize.dadosModal.numeroEndereco = dispensaSelecionada.endereco.numeroEnderecoOrdemServico;
        this.modalCustomSize.dadosModal.numeroEnderecoSaida = dispensaSelecionada.enderecoSaida.numeroEnderecoOrdemServico;
        this.modalCustomSize.dadosModal.nomeEnderecoSaida = dispensaSelecionada.enderecoSaida.nomeEndereco;
        this.modalCustomSize.dadosModal.responsavelDispensa = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.dadosModal.descricaoObservacao = dispensaSelecionada.dispensaUnidade.descricaoObservacao;
        this.modalCustomSize.dadosModal.dataDispensa = this.formataDataBanco(dispensaSelecionada.dispensaUnidade.dataDispensa);
        this.modalCustomSize.dadosModal.dataDispensaFormatada = this.formataDataBancoTipoPadrao(this.modalCustomSize.dadosModal.dataDispensa);
        this.modalCustomSize.dadosModal.indicadorStatus = dispensaSelecionada.dispensaUnidade.indicadorStatus;

        this.modalCustomSize.dadosModal.produtosDispensados = [];
        this.modalCustomSize.dadosModal.produtosDispensados = await this.listarProdutosDispensados(dispensaSelecionada.dispensaUnidade.numeroDispensaUnidade);
        this.modalCustomSize.dadosModal.produtosDispensadosExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "Visualizar Dispensa";
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = true;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = false;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },
    //#endregion

    //#region FORMATADORES
    formataDataBanco(data) {
      if (data) {
        if (data.includes("T")) {
          const dataSeparada = data.split("T")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else if (data.includes(" ")) {
          const dataSeparada = data.split(" ")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else {
          const ano = data.split("-")[0];
          const mes = data.split("-")[1];
          const dia = data.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        }
      } else {
        return null;
      }
    },

    formataDataBancoTipoPadrao(data) {
      if (data) {
        if (data.includes("T")) {
          const dataSeparada = data.split("T")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else if (data.includes(" ")) {
          const dataSeparada = data.split(" ")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else {
          const ano = data.split("-")[0];
          const mes = data.split("-")[1];
          const dia = data.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        }
      } else {
        return null;
      }
    },
    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },
    formatarData(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    analizarData(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //#endregion
    //#region GerarPDF
    async imprimirTransferencia(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Comprovante de Transferencia",
        },
        content: [
          { text: "Comprovante de Transferencia", style: "header" },
          { text: "Numero da Dispensa: " + conteudo.dispensaUnidade.numeroDispensaUnidade, style: "subheader" },
        ],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 16,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      const response = await axios.put("listaitensdispensaunidade", { numeroDispensaUnidade: conteudo.dispensaUnidade.numeroDispensaUnidade }, this.config);
      if (response.data.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of response.data) {
          tabela[0].table.body.push([item.numeroItemUnidade, item.lote, item.nomeItem, item.validade, item.quantidadeDispensada]);
        }

          docDefinition.content.push(tabela);
        } else {
          let itens = { text: "Sem itens dispensados!", style: "subtext" };
          docDefinition.content.push(itens);
        }

        docDefinition.content.push({ text: "Enviado por: " + conteudo.enderecoSaida.nomeEndereco, style: "nameText" });
        docDefinition.content.push({ canvas: [{ type: "line", x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1, style: "line" }] });
        docDefinition.content.push({ text: "Recebido por: " + conteudo.endereco.nomeEndereco, style: "nameText" });
        if(conteudo.dispensaUnidade.indicadorStatus == 0){
         docDefinition.content.push({ text: "Está lista está aguardando aprovação da unidade", style: "textSignature" });
        }
        if(conteudo.dispensaUnidade.indicadorStatus == 1){
         docDefinition.content.push({ text: "Esta lista foi Recebida pela Unidade", style: "textSignature" });
        }
        if(conteudo.dispensaUnidade.indicadorStatus == 2){
         docDefinition.content.push({ text: "Esta lista foi Recusada pela Unidade", style: "textSignature" });
        }
        if(conteudo.funcionario.nomeFuncionario){
            docDefinition.content.push({ text: "Funcionario: " + conteudo.funcionario.nomeFuncionario, style: "nameText" });
          }
          if (conteudo.endereco.descricaoEndereco) {
            docDefinition.content.push({ text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador });
          }
          if (conteudo.endereco.descricaoBairro) {
            docDefinition.content.push({ text: "Bairro: " + conteudo.endereco.descricaoBairro });
          }
          docDefinition.content.push({ text: "Municipio: Itu - SP" });
          if (conteudo.endereco.descricaoCep) {
            docDefinition.content.push({ text: "CEP: " + conteudo.endereco.descricaoCep });
          }
      docDefinition.content.push({ text: "Data: " + this._formatStringInBrazilianDateFormat(dataAtual) + " Hora: " + formattedTime });

      pdfMake.createPdf(docDefinition).open();

    },
    //#endregion
  },
};
</script>
